export default __webpack_public_path__ + "static/media/cu_medi_logo_landscape.80a10222.png";